import { getContrastingTextColor, getContrastingTextClass } from '@/utils/color';

export default {
	computed: {
		contrastOnPrimary() {
			return getContrastingTextClass(this.$vuetify.theme.themes.light.primary);
		},
		contrastOnSecondary() {
			return getContrastingTextClass(this.$vuetify.theme.themes.light.secondary);
		},
		contrastOnAccent() {
			return getContrastingTextClass(this.$vuetify.theme.themes.light.accent);
		},
		contrastColorOnPrimary() {
			return getContrastingTextColor(this.$vuetify.theme.themes.light.primary);
		},
		contrastColorOnSecondary() {
			return getContrastingTextColor(this.$vuetify.theme.themes.light.secondary);
		},
		contrastColorOnAccent() {
			return getContrastingTextColor(this.$vuetify.theme.themes.light.accent);
		},
	},
};
